import { DataSchemaItemGroupDto, DataSchemaItemGroupKind } from 'src/app/services/api.services';
import { INamedElement, NamedElementHierarchyCollection } from './Collections';
import { DataSchema } from './DataSchema';
import { DataSchemaItem } from './DataSchemaItem';
import { ItemDisplayOptions } from './ItemDisplayOptions';
import { deepClone } from 'src/app/shared/clone/cloner-service';

export class DataSchemaItemGroup implements INamedElement {
  readonly items = new DataSchemaItemGroup.ItemCollection(this);

  constructor(
    public readonly schema: DataSchema,
    public readonly name: string) { }

  get model() { return this.source.model; }
  get source() { return this.schema.source; }

  kind: DataSchemaItemGroupKind = DataSchemaItemGroupKind.Default;

  itemDisplay = new ItemDisplayOptions({});

  setFromDto(dto: DataSchemaItemGroupDto) {
    this.kind = dto.kind;

    this.itemDisplay = new ItemDisplayOptions(dto.itemDisplay);

    dto.items.forEach(x => this.items.add(x.name).setFromDto(x));
  }

  toDto(): DataSchemaItemGroupDto {
    return {
      name: this.name,
      kind: this.kind,
      itemDisplay: deepClone(this.itemDisplay.dto),
      items: [...this.items.map(x => x.toDto())],
    };
  }
}

export namespace DataSchemaItemGroup {
  export class ItemCollection extends NamedElementHierarchyCollection<DataSchemaItem> {
    constructor(public readonly g: DataSchemaItemGroup) {
      super();
    }

    add(name: string) {
      let item = new DataSchemaItem(this.g, name);
      this._add(item);
      return item;
    }

    getOrAdd(name: string) {
      return this.find(name) ?? this.add(name);
    }

    remove(item: DataSchemaItem) {
      return this._remove(item);
    }

    protected findChild(item: DataSchemaItem, name: string) {
      return item.children.find(name);
    }

    protected getBase() {
      return this.g.model.base
        ?.schemas.find(this.g.source.reference, this.g.schema.reference)
        ?.itemGroups.find(this.g.name)?.items;
    }

    protected getExtensions() {
      return this.g.model.base?.extensions.map(
        x => x.schemas.find(this.g.source.reference, this.g.schema.reference)
          ?.itemGroups.find(this.g.name)?.items) ?? [];
    }
  }
}
